import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import CreationToolOutputType from '../../../../../types/output-type'
import { SquareButton } from '../../../../buttons'
import { CreationToolUploadContext } from '../../../manager'
import { CreationToolUploadSource } from '../../../types'
import LabelInput from './input'

const Container = styled.div<{ editable: boolean }>`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    font-size: 15px;
    height: 100%;
    line-height: 1;
    margin-right: auto;
    min-width: 0; // this is needed for text truncating in flexbox
    pointer-events: ${({ editable }) => (editable ? 'auto' : 'none')};
    position: relative;
`

const Label = styled.span`
    color: #fff;
    font-weight: bold;
    margin-right: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

const EditIcon = styled(SquareButton)`
    background: transparent;
    flex-shrink: 0;
    opacity: 0.25;

    &:hover {
        background: #000;
        opacity: 1;
    }
`

type Props = {
    disabled?: boolean
    source: CreationToolUploadSource
}

const CreationUploadItemLabel = ({ source: uploadSource, disabled = false }: Props) => {
    const { updateUploadSource } = useContext(CreationToolUploadContext)
    const [isEditing, setIsEditing] = useState<boolean>(false)
    const { outputType, title, source: src } = uploadSource
    const label = title || (typeof src.source === 'string' ? src.source : src.source.name)
    const isEditable = !disabled && outputType === CreationToolOutputType.Video

    const onTitleSave = (title: string) => {
        updateUploadSource({ ...uploadSource, title })
        setIsEditing(false)
    }

    return (
        <Container editable={isEditable} style={isEditing ? { width: '100%' } : undefined}>
            {isEditing ? (
                <LabelInput source={uploadSource} onSave={onTitleSave} />
            ) : isEditable ? (
                <>
                    <Label style={{ cursor: 'pointer' }} onClick={() => setIsEditing(true)}>
                        {label}
                    </Label>
                    <EditIcon className="ss-write" onClick={() => setIsEditing(true)} />
                </>
            ) : (
                <Label>{label}</Label>
            )}
        </Container>
    )
}

export default CreationUploadItemLabel
